import { memo, useEffect, useState } from "react";
import "react-circular-progressbar/dist/styles.css";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { CalorieCenterContent } from "./calorie-pie-chart-center-content";
interface CaloriePieChartProps {
  proteinPercentage: number;
  proteinColorClassName: string;
  carbsPercentage: number;
  carbsColorClassName: string;
  fatPercentage: number;
  fatColorClassName: string;
  totalCalories: number;
}

const CaloriePieChart = memo(function CaloriePieChart({
  proteinPercentage,
  proteinColorClassName,
  carbsPercentage,
  carbsColorClassName,
  fatPercentage,
  fatColorClassName,
  totalCalories,
}: CaloriePieChartProps) {
  const [shouldRenderChart, setShouldRenderChart] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setShouldRenderChart(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  const data = [
    {
      name: "Protein",
      value: proteinPercentage,
      colorClassName: proteinColorClassName,
    },
    {
      name: "Carbs",
      value: carbsPercentage,
      colorClassName: carbsColorClassName,
    },
    {
      name: "Fat",
      value: fatPercentage,
      colorClassName: fatColorClassName,
    },
  ];

  const renderCustomLabel = () => null;

  return (
    <div className="relative w-80 h-80 flex items-center justify-center">
      {shouldRenderChart ? (
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomLabel}
              outerRadius={140}
              innerRadius={120}
              startAngle={135}
              endAngle={495}
              fill="#8884d8"
              dataKey="value"
              stroke="none"
              strokeWidth={0}
              paddingAngle={4} // Gap between segments
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  className={entry.colorClassName}
                  stroke="none"
                  strokeWidth={0}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <div className="w-64 h-64 rounded-full bg-gradient-to-b from-gray-100 to-gray-200 animate-pulse" />
      )}

      <CalorieCenterContent totalCalories={totalCalories} />
    </div>
  );
});

export default CaloriePieChart;
